import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import api from '../utils/api';
import moment from 'moment';
import './styles/Kidola.css'; // Adjust the path as necessary

import { useNavigate } from 'react-router-dom';

const StudentLevelupRequestDetailPage = ({ isSidebarCollapsed }) => {
    const { levelupRequestId } = useParams();
    const [student, setStudent] = useState(null);
    const [levelup, setLevelup] = useState(null);
    const navigate = useNavigate();

    useEffect(() => {
        const fetchStudentDetails = async () => {
            try {
                const response = await api.get(`/student/levelup/detail/${levelupRequestId}`);
                const studentData = response.data.data.studentData || null;
                const studentLevelupRequestData = response.data.data.studentLevelupRequest || null;
                setStudent(studentData);
                setLevelup(studentLevelupRequestData);
            } catch (error) {
                console.error("Failed to fetch student levelup request details", error);
            }
        };

        fetchStudentDetails();
        
        
        
        
    }, [levelupRequestId]);
   
    const handleSubmit = (status) => {
        
        const confirmation = window.confirm('Are you sure you want to proceed with this action?');
        if (!confirmation) {
            return;
        }

        const requestBody = {
            data: {
                levelUpData: {
                    status_name: status  
                }
            }
        };

        api.put(`student/levelup/update/${levelupRequestId}`, requestBody)
        .then(response => {
            const successMessage = response.data.message;
            console.log(successMessage);
            navigate('/success', { state: { message: successMessage } });
            
        })
        .catch(error => {
            console.error('Error adding student:', error);
            navigate('/error', { state: { message: 'Please ask to administrator!' } });
        });
    };

    if (!student) return <p>Loading Level Up Request details...</p>;

    return (
        <div className={`page-content ${isSidebarCollapsed ? 'collapsed' : ''} spp-payment`}>
            <div className="page-title">Student Level Up Detail</div>
            <div className="form-container">
                <div className="section">
                    <h3 className="section-header">Student Data</h3>
                    <table>
                        <tbody>
                            <tr>
                                <td>Student Name</td>
                                <td>:</td>
                                <td>{student.student_name}</td>
                            </tr>
                            <tr>
                                <td>Branch</td>
                                <td>:</td>
                                <td>{student.Branch.branch_name}</td>
                            </tr>
                            <tr>
                                <td>Current Program</td>
                                <td>:</td>
                                <td>{student.StudentLevels[0].mainProgram.program_name}</td>
                            </tr>
                            <tr>
                                <td>Current Level</td>
                                <td>:</td>
                                <td>{student.StudentLevels[0].Level.level_name}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div className="section">
                    <h3 className="section-header">Level Up Data</h3>
                    <table>
                        <tbody>
                            <tr>
                                <td>Teacher Name</td>
                                <td>:</td>
                                <td>{levelup.Teacher.teacher_name}</td>
                            </tr>
                            <tr>
                                <td>Shared Teacher Name</td>
                                <td>:</td>
                                <td>{levelup.shared_teacher ? levelup.shared_teacher.teacher_name : '-'}</td>
                            </tr>
                            <tr>
                                <td>Requested Program</td>
                                <td>:</td>
                                <td>{levelup.Program.program_name}</td>
                            </tr>
                            <tr>
                                <td>Requested Level</td>
                                <td>:</td>
                                <td>{levelup.Level.level_name}</td>
                            </tr>
                            <tr>
                                <td>Status</td>
                                <td>:</td>
                                <td>{levelup.Status.status_name}</td>
                            </tr>
                            <tr>
                                <td>Requested On</td>
                                <td>:</td>
                                <td>{moment(levelup.requested_on).format('DD MMMM YYYY HH:mm:ss')}</td>
                            </tr>
                            {levelup.approved_on!=null ?
                            <tr>
                                <td>Approved On</td>
                                <td>:</td>
                                <td>{moment(levelup.approved_on).format('DD MMMM YYYY HH:mm:ss')}</td>
                            </tr>
                            :""}
                            {levelup.rejected_on!=null ?
                            <tr>
                                <td>Rejected On</td>
                                <td>:</td>
                                <td>{moment(levelup.rejected_on).format('DD MMMM YYYY HH:mm:ss')}</td>
                            </tr>
                            :""}
                        </tbody>
                    </table>
                </div>
                {levelup.Status.status_name === "WAITING APPROVAL"?
                <div className="approve-reject-container">
                    <button className="approve-reject-button" onClick={() => handleSubmit('APPROVED')}>Approve</button>  
                    <button className="profile-button" onClick={() => handleSubmit('REJECTED')}>Reject</button>
                </div>
                :""}
                <div className="search-container">  
                    <button onClick={() => navigate(`/`)}>Back</button>
                </div>
            </div>
        </div>
    );
};

export default StudentLevelupRequestDetailPage;
